import "../styles/default.scss";

import React, { useState } from "react";
import PropTypes from "prop-types";

import withTranslations from "../../../../../hocs/withTranslations";
import { FE_STOCK_PAGE_URL_PATTERN } from "../../../../../lib/tvFullScreenQuery";
import SearchBar from "../../SearchBar/";

const TVChartStocksList = ({
  translate,
  close,
  onStockSelect,
  resultUrlPattern = FE_STOCK_PAGE_URL_PATTERN
}) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);

  return (
    <div className="tv-chart-options-window wide tvchart-stocks-list">
      <h4>
        <span className="title">{translate("Select stock")}</span>
        <span className="close-button" onClick={() => close()}>
          <i className="fal fa-times" />
        </span>
      </h4>
      <SearchBar
        inContent
        resultUrlPattern={resultUrlPattern}
        searchAlwaysOpen={true}
        searchBarOpen={searchBarOpen}
        setSearchBarOpen={setSearchBarOpen}
        onStockSelect={onStockSelect}
      />
    </div>
  );
};

TVChartStocksList.propTypes = {
  translate: PropTypes.func,
  close: PropTypes.func,
  onStockSelect: PropTypes.func,
  resultUrlPattern: PropTypes.string
};

export default withTranslations(TVChartStocksList);
